import { CircleArrowDown, CircleArrowUp, CircleHelp } from 'lucide-react';

import { SignalDirection } from '../types';

export function renderSignalDirectionIcon(signalDirection: SignalDirection, title: string) {
  const direction = signalDirection?.toLowerCase();

  if (direction === SignalDirection.UNKNOWN) {
    return (
      <div className="flex items-center justify-center" title={title}>
        <CircleHelp className="h-4 w-4 text-foreground" />
      </div>
    );
  }

  if (direction === SignalDirection.APPROACHING) {
    return (
      <div className="flex items-center justify-center" title={title}>
        <CircleArrowDown className="h-4 w-4 text-destructive" />
      </div>
    );
  }

  if (direction === SignalDirection.RECEDING) {
    return (
      <div className="flex items-center justify-center" title={title}>
        <CircleArrowUp className="h-4 w-4 text-success" />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center">
      <span className="text-xs text-gray-light">-</span>
    </div>
  );
}
